<template>
  <div v-cloak>
    <div class="page_bg">
      <div class="page_box">
        <!-- 顶部标题栏 -->
        <div class="title_box">
          <div class="title">
            <span class="title_icon">
              <i class="el-icon-school"></i>
            </span>
            全部班级
            <span class="title_badge" v-if="infoCount">{{ infoCount }} 个班级</span>
          </div>
          <div class="search_box">
            <el-input size="small" placeholder="请输入班级名称搜索..." prefix-icon="el-icon-search" v-model="searchInput"
              clearable @input="inputChage" @keyup.enter.native="searchInfo">
            </el-input>
            <div class="saarch_btn" @click="searchInfo">
              <i class="el-icon-search"></i>
              <span>搜索</span>
            </div>
          </div>
        </div>

        <!-- 班级列表 -->
        <div class="class_box" @scroll="handleScroll" v-if="classInfo.length > 0">
          <div class="class_item" v-for="(item, index) in classInfo" :key="index"
            :style="{ animationDelay: (index % 10) * 0.06 + 's' }">
            <!-- 左侧彩条 -->
            <div class="card_accent"></div>
            <!-- 第一行：标题 + 类型 -->
            <div class="row_1">
              <div class="title title_link" @click="jumpExamTab(index)">
                <i class="el-icon-folder-opened title_folder"></i>
                {{ item.pro_name }}
              </div>
              <div class="type">{{ item.class_type.name }}</div>
            </div>
            <!-- 第二行：信息标签 -->
            <div class="row_2">
              <div class="base_info">
                <i class="el-icon-date info_icon"></i>
                <span>{{ item.course_time.name }} — {{ item.finish_time.name }}</span>
              </div>
              <div class="base_info">
                <i class="el-icon-notebook-2 info_icon"></i>
                <span>科目数量 <em>{{ item.sub_num }}</em></span>
              </div>
              <div class="base_info">
                <i class="el-icon-document info_icon"></i>
                <span>今日考试 <em>{{ item.grant_num }}</em></span>
              </div>
              <div class="base_info">
                <i class="el-icon-user info_icon"></i>
                <span>{{ item.charge_name }}</span>
              </div>
            </div>
            <!-- 进入按钮 -->
            <div class="jump_btn" @click="jumpExamTab(index)" v-throttle>
              <span>进入班级</span>
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>

        <!-- 空状态 -->
        <div v-else class="empty_wrap">
          <nullBox></nullBox>
        </div>
      </div>
    </div>

    <div class="page_end_fixed">
      <endBox></endBox>
    </div>
  </div>
</template>

<script>
import { _getClassList, _setClassDefault } from "../api/className"
export default {

  created() {
    this.getClassList()
  },

  mounted() { },
  data() {
    return {
      pageNumber: 1,
      pageSize: 15,
      searchInput: "",
      infoCount: null,
      classInfo: [],
    };
  },
  methods: {
    inputChage() {
      if (this.searchInput == "" || this.searchInput == null || this.searchInput == undefined) {
        this.pageNumber = 1
        this.getClassList()
      }
    },
    handleScroll(event) {
      const dialog = event.target;
      if (dialog.scrollHeight - dialog.scrollTop === dialog.clientHeight) {
        console.log("滚动到底了");
        if (this.classInfo.length >= this.infoCount) {

          console.log("数据没了");
          return false
        }
        this.pageNumber = this.pageNumber + 1
        this.getClassList()
      }

    },
    searchInfo() {
      this.pageNumber = 1
      this.getClassList()
    },
    async getClassList() {
      let params = {
        listRows: this.pageSize,
        page: this.pageNumber,
        pro_name: this.searchInput
      }
      let res = await _getClassList(params)
      console.log(res.data);
      if (this.pageNumber == 1) {
        this.classInfo = res.data.data
        this.infoCount = res.data.total
      } else {
        this.classInfo = this.classInfo.concat(res.data.data)
        this.infoCount = res.data.total
      }
      console.log(this.classInfo);
    },
    async jumpExamTab(index) {
      let params = {
        pro_id: this.classInfo[index].id,
        isShowErr:true
      }
      await _setClassDefault(params)
      window.localStorage.setItem("proID", this.classInfo[index].id)
      window.localStorage.setItem("className", this.classInfo[index].pro_name)
      this.$router.push({ name: "ExamTab", params: { className: this.classInfo[index].pro_name } });

    },
  },
};
</script>
<style scoped>
/* ========== 页面背景 ========== */
.page_bg {
  background: linear-gradient(160deg, #f0f2ff 0%, #f7f8fc 40%, #f5f7fa 100%);
  padding-bottom: 20px;
}

.page_box {
  width: 1160px;
  margin: auto;
  padding: 0 0 20px;
}

/* ========== 顶部标题栏 ========== */
.title_box {
  width: 100%;
  height: 68px;
  box-sizing: border-box;
  padding: 0 28px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  margin-top: 24px;
  margin-bottom: 22px;
  border-radius: 14px;
  box-shadow: 0 4px 20px rgba(100, 110, 255, 0.07), 0 1px 4px rgba(0, 0, 0, 0.04);
}

.title_box .title {
  color: #1e2330;
  font-weight: 700;
  font-size: 20px;
  margin-left: 2px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.title_icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #646eff, #8b93ff);
  border-radius: 10px;
  color: #fff;
  font-size: 18px;
  box-shadow: 0 3px 10px rgba(100, 110, 255, 0.3);
}

.title_badge {
  display: inline-block;
  padding: 2px 12px;
  background: linear-gradient(135deg, #eef0ff, #e8eaff);
  color: #646eff;
  font-size: 12px;
  font-weight: 600;
  border-radius: 20px;
  margin-left: 4px;
  letter-spacing: 0.5px;
}

/* ========== 搜索区域 ========== */
.search_box {
  display: flex;
  align-items: center;
}

.search_box /deep/ .el-input {
  width: 260px;
}

.search_box /deep/ .el-input__inner {
  height: 38px;
  line-height: 38px;
  border-radius: 19px;
  border: 1.5px solid #e4e7ed;
  padding-left: 38px;
  font-size: 13px;
  transition: all 0.3s ease;
  background: #f7f8fa;
}

.search_box /deep/ .el-input__inner:focus {
  border-color: #646eff;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(100, 110, 255, 0.1);
}

.search_box /deep/ .el-input__prefix {
  left: 14px;
  line-height: 38px;
  color: #b0b5c0;
}

.saarch_btn {
  height: 38px;
  padding: 0 20px;
  border-radius: 19px;
  background: linear-gradient(135deg, #646eff, #8b93ff);
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  margin-left: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  transition: all 0.3s;
  box-shadow: 0 4px 14px rgba(100, 110, 255, 0.28);
}

.saarch_btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(100, 110, 255, 0.4);
}

.saarch_btn:active {
  transform: translateY(0);
}

/* ========== 班级列表容器 ========== */
.class_box {
  width: 100%;
  height: 65vh;
  box-sizing: border-box;
  padding: 4px 4px 20px;
  margin-top: 4px;
  overflow-y: auto;
}

/* 自定义滚动条 */
.class_box::-webkit-scrollbar {
  width: 5px;
}

.class_box::-webkit-scrollbar-track {
  background: transparent;
}

.class_box::-webkit-scrollbar-thumb {
  background: #d0d3da;
  border-radius: 10px;
}

.class_box::-webkit-scrollbar-thumb:hover {
  background: #b8bcc4;
}

/* ========== 班级卡片 ========== */
.class_item {
  width: 100%;
  min-height: 130px;
  background: #fff;
  box-sizing: border-box;
  padding: 22px 28px 22px 32px;
  position: relative;
  margin-bottom: 16px;
  border-radius: 12px;
  border: 1px solid #eceef3;
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: default;
  overflow: hidden;
  animation: cardFadeIn 0.5s ease both;
}

@keyframes cardFadeIn {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.class_item:hover {
  border-color: rgba(100, 110, 255, 0.25);
  box-shadow: 0 8px 30px rgba(100, 110, 255, 0.1), 0 2px 8px rgba(0, 0, 0, 0.04);
  transform: translateY(-3px);
}

/* 左侧彩条 */
.card_accent {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: linear-gradient(180deg, #646eff, #a5abff);
  border-radius: 4px 0 0 4px;
  opacity: 0.7;
  transition: all 0.3s;
}

.class_item:hover .card_accent {
  opacity: 1;
  width: 5px;
}

/* 第一行 */
.class_item .row_1 {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.class_item .row_1 .title {
  color: #1e2330;
  font-weight: 700;
  font-size: 17px;
  transition: color 0.25s;
  display: flex;
  align-items: center;
  gap: 8px;
}

.title_folder {
  color: #646eff;
  font-size: 18px;
  opacity: 0.7;
}

.class_item .row_1 .title_link {
  cursor: pointer;
}

.class_item .row_1 .title_link:hover {
  color: #646eff;
}

.class_item .row_1 .title_link:hover .title_folder {
  opacity: 1;
}

.class_item .row_1 .type {
  padding: 4px 14px;
  background: linear-gradient(135deg, #eef0ff, #e4e7ff);
  color: #646eff;
  font-size: 12px;
  font-weight: 600;
  border-radius: 20px;
  letter-spacing: 0.5px;
  border: 1px solid rgba(100, 110, 255, 0.12);
}

/* 第二行信息 */
.class_item .row_2 {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  color: #6b7280;
  font-size: 13px;
  margin-top: 16px;
  padding-right: 140px;
}

.class_item .row_2 .base_info {
  margin-right: 0;
  padding: 5px 12px;
  background: #f5f6f8;
  border-radius: 8px;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 5px;
  transition: background 0.2s;
}

.class_item .row_2 .base_info:hover {
  background: #eef0ff;
}

.info_icon {
  color: #646eff;
  font-size: 14px;
  opacity: 0.65;
}

.class_item .row_2 .base_info em {
  font-style: normal;
  font-weight: 700;
  color: #646eff;
  margin-left: 2px;
}

/* 进入按钮 */
.class_item .jump_btn {
  height: 36px;
  padding: 0 22px;
  border-radius: 18px;
  background: linear-gradient(135deg, #646eff, #8b93ff);
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  position: absolute;
  right: 28px;
  bottom: 22px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 14px rgba(100, 110, 255, 0.22);
  letter-spacing: 1px;
}

.class_item .jump_btn::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 60%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s;
}

.class_item .jump_btn:hover::after {
  left: 120%;
}

.class_item .jump_btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 22px rgba(100, 110, 255, 0.38);
}

.class_item .jump_btn:active {
  transform: translateY(0);
}

.class_item .jump_btn i {
  font-size: 12px;
  transition: transform 0.25s;
}

.class_item .jump_btn:hover i {
  transform: translateX(4px);
}

/* 空状态居中 */
.empty_wrap {
  display: flex;
  justify-content: center;
  padding-top: 80px;
}
</style>
